import { TweenMax, TimelineMax } from 'gsap';
import { useEffect } from 'react';
import css from './index.module.scss';
import GsapB1 from './gsapB1/gsapB1';
import GsapB2 from './gsapB1/gsapB2';
import GsapBText1 from './gsapBText1';

export default function AnimationB({}: any) {
    useEffect(() => {
        const controller = new ScrollMagic.Controller();

        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.animationB',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '150%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.animationB .gsapB1 .msg-trigger1', 0.1, {
            opacity: 0,
            y: -40,
        });
        const tweenA2 = TweenMax.to('.animationB .gsapB1 .msg-trigger2', 0.1, {
            opacity: 0,
        });
        const tweenA3 = TweenMax.to('.animationB .gsapB1 .img-box', 0.1, {
            opacity: 0,
        });
        const tweenA4 = TweenMax.to('.animationB .gsapB2 .msg-trigger1', 0.1, {
            opacity: 1,
            y: -40,
        });
        const tweenA5 = TweenMax.to('.animationB .gsapB2 .msg-trigger2', 0.1, {
            opacity: 1,
        });
        const tweenA6 = TweenMax.to('.animationB .gsapB2 .img-box', 0.1, {
            opacity: 1,
        });
        const tweenA7 = TweenMax.to('.animationB .gsapB2 .msg-trigger1', 0.1, {
            opacity: 0,
            y: -40,
        });
        const tweenA8 = TweenMax.to('.animationB .gsapB2 .msg-trigger2', 0.1, {
            opacity: 0,
        });
        const tweenA9 = TweenMax.to('.animationB .gsapB2 .img-box', 0.1, {
            opacity: 0,
        });
        const tweenA16 = TweenMax.to('.animationB .gsapBText1', 0.05, {
            opacity: 1,
        });

        const timelineA1 = new TimelineMax();
        timelineA1
            .add(tweenA1)
            .add(tweenA2, 0)
            .add(tweenA3, 0)
            .add(tweenA4, 0.05)
            .add(tweenA5, 0.05)
            .add(tweenA6, 0)
            .add(tweenA7, 0.3)
            .add(tweenA8, 0.3)
            .add(tweenA9, 0.3)
            .add(tweenA16, 0.35);

        sceneA1.setTween(timelineA1);
        controller.addScene(sceneA1);

        return () => {
            controller && controller.destroy();
            sceneA1 && sceneA1.destroy();
            timelineA1 && timelineA1.kill();
        };
    }, []);

    return (
        <>
            <div id="animationB-trigger-1"></div>
            <div id="animationB-trigger-2"></div>
            <div id="animationB-trigger-3"></div>
            <div className={`${css.animationB} animationB`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani ef-scroll-ani-a1">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapB1 />
                            </div>
                        </div>
                    </div>
                    <div className="ef-scroll-ani ef-scroll-ani-a2">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapB2 />
                            </div>
                        </div>
                    </div>
                    <div className="ef-scroll-ani ef-scroll-ani-a4">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GsapBText1 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
